import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function roleHome(role) {
    if (role === "faculty") return "/faculty-portal";
    if (role === "organization") return "/org-portal";
    if (role === "admin") return "/admin";
    return "/dashboard";
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!localStorage.getItem("tb_session")) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => { localStorage.removeItem("tb_session"); setUser(null); })
            .finally(() => setLoading(false));
    }, []);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("tb_session", "1");
        setUser(data);
        return data;
    }, []);

    const register = useCallback(async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("tb_session", "1");
        setUser(data);
        return data;
    }, []);

    const googleSession = useCallback(async (session_id) => {
        const { data } = await api.post("/auth/google/session", { session_id });
        localStorage.setItem("tb_session", "1");
        setUser(data);
        return data;
    }, []);

    const logout = useCallback(async () => {
        try { await api.post("/auth/logout"); } catch (e) {}
        localStorage.removeItem("tb_session");
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, googleSession }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}

export function startGoogleLogin() {
    const redirect = encodeURIComponent(`${window.location.origin}/auth/callback`);
    window.location.href = `https://auth.emergentagent.com/?redirect=${redirect}`;
}
